<template>
    <div class="">
        <Header></Header>

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize">{{ refs }}

                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->

                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->


        <div v-if="pgLoading" class="row h-100">
            <div class="container text-center">
                <div class="spinner-grow mt-5" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">        
                    <div class="col-md-8 mb-5">


                    <!-- Card Content -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabContent" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Content')"
                                            aria-expanded="false" 
                                            aria-controls="collapseContent" 
                                            data-toggle="collapse"
                                            data-target="#collapseContent">Slider
                                            <span id="iconToggleContent" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseContent" 
                                        class="collapse show" 
                                        aria-labelledby="TabContent" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Title -->
                                        <div class="form-group">
                                            <label for="input1">Title</label>
                                            <input class="form-control"
                                                    id="input1"  
                                                    type="text" 
                                                    v-model="row.title">
                                        </div>
                                        <!-- End Title -->

                                        <!-- Sort -->
                                        <div class="form-group">
                                            <label for="input2">Sort</label>
                                            <input class="form-control"
                                                    id="input2"  
                                                    type="number"
                                                    min="0" 
                                                    v-model.number="row.sort">
                                        </div>
                                        <!-- End Sort -->

                                        <!-- Button -->
                                        <div class="form-group">
                                            <label for="input3">Button</label>
                                            <input class="form-control"
                                                    id="input3"  
                                                    type="text"
                                                    v-model="row.button">
                                        </div>
                                        <!-- End Button -->

                                        <!-- Link -->
                                        <div class="form-group">
                                            <label for="input4">Link</label>
                                            <input class="form-control"
                                                    id="input4"  
                                                    type="text"
                                                    v-model="row.link">
                                        </div>
                                        <!-- End Link -->

                                        <!-- Iframe -->
                                        <div class="form-group">
                                            <label for="input5">Iframe</label>
                                            <input class="form-control"
                                                    id="input5"  
                                                    type="text"
                                                    v-model="row.iframe">
                                        </div>
                                        <!-- End Iframe -->
                                            
                                        <!-- Body -->
                                        <div class="form-group">
                                            <label for="input6">Body</label>
                                            <editor
                                                id="input6"
                                                v-model="row.body"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Body -->

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Card Content -->

                </div>




                    <!-- ******* SideNavbar ******** -->
                    <div class="col-md-4 mb-5">

                        <!-- Nav Language -->
                        <div class="card">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavLanguage" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Language')" 
                                            aria-expanded="false" 
                                            aria-controls="collapseNavLanguage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavLanguage">Language
                                            <span id="iconToggleLanguage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavLanguage" 
                                        class="collapse" 
                                        aria-labelledby="NavLanguage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Language -->
                                        <div class="form-group">
                                            <div v-if="languageLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!languageLoading" 
                                                    v-model="row.language_id">
                                                    <option value="">Select Language</option>
                                                    <option v-for="(language, index) in languages" 
                                                            :key="index"
                                                            :value="language.id">
                                                            {{ language.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <!-- End Language -->
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Nav Language -->
                        <!-- NavTwo -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('Image')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseNavImage">Featued Image
                                            <span id="iconToggleImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavImage" 
                                        class="collapse" 
                                        aria-labelledby="NavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                             <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img v-if="row.image_preview"
                                                    :src="row.image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onImageChange"
                                                    accept="image/*">
                                            </div>
                                            <!-- Image -->

                                            <!-- Image Alt -->
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_alt">
                                            </div>
                                            <!-- End Image Alt -->

                                            <!-- Image Title -->
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.image_title">
                                            </div>
                                            <!-- End Image Title -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavTwo -->

                        <!-- Nav Mobile Image -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="MobileNavImage" class="card-header">
                                        <h2 class="h4 card-header-title"
                                            @click="collapseToggle('MobileImage')"  
                                            aria-expanded="false" 
                                            aria-controls="collapseMobileNavImage" 
                                            data-toggle="collapse" 
                                            data-target="#collapseMobileNavImage">Mobile Featured Image
                                            <span id="iconToggleMobileImage" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseMobileNavImage" 
                                        class="collapse" 
                                        aria-labelledby="MobileNavImage" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                             <!-- Image -->
                                            <div class="form-group">
                                                <label>Image</label>
                                                <img v-if="row.mobile_image_preview"
                                                    :src="row.mobile_image_preview" 
                                                    class="mb-2 custom-image">
                                                <input type="file" 
                                                    class="form-control" 
                                                    ref="myDropify" 
                                                    v-on:change="onMobileImageChange"
                                                    accept="image/*">
                                            </div>
                                            <!-- Image -->

                                            <!-- Image Alt -->
                                            <div class="form-group">
                                                <label>Image alt</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.mobile_image_alt">
                                            </div>
                                            <!-- End Image Alt -->

                                            <!-- Image Title -->
                                            <div class="form-group">
                                                <label>Image title</label>
                                                <input type="text" 
                                                    class="form-control"
                                                    v-model="row.mobile_image_title">
                                            </div>
                                            <!-- End Image Title -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Mobile Image -->


                        <!-- NavThree -->
                        <div class="card mt-5">
                            <div class="card-body">
                                <div id="accordionNav" class="accordion">
                                    <div id="NavStatus" class="card-header">
                                        <h2 class="h4 card-header-title" 
                                            @click="collapseToggle('Status')"
                                            aria-expanded="false" 
                                            aria-controls="collapseNavStatus" 
                                            data-toggle="collapse"
                                            data-target="#collapseNavStatus">Status & Visibility
                                            <span id="iconToggleStatus" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                            </span>
                                        </h2>
                                    </div>
                                    <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        <div class="col-12 pt-3">
                                            <!-- Status -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch1" 
                                                        :checked="row.status"
                                                        @click="onStatus">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch1"
                                                        v-html="(row.status) ? 'Active' : 'Inactive'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End Status -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End NavThree -->

                        </div>
                    </div>
                </div>
                <!-- End Content -->

                    

                    <div class="col-md-12 row">
                        <div class="form-group mr-2">
                            <button class="btn btn-primary" :disabled="btnLoading">
                                <span v-if="btnLoading">
                                    <span class="spinner-grow spinner-grow-sm mr-1" 
                                        role="status" aria-hidden="true">
                                    </span>Loading...
                                </span>
                                <span v-if="!btnLoading" class="ti-check-box"></span>
                                <span v-if="!btnLoading"> Update Slider</span>
                            </button>
                        </div>

                        <div class="form-group">
                            <button type="button" class="btn btn-danger" 
                                :disabled="btnLoading" 
                                @click="cancel">
                                <span class="ti-close"></span>
                                <span> Cancel </span>
                            </button>
                        </div>
                    </div>


                </form>
            </div>


                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';
    
    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Footer,
            Editor
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // row
                    button: '',
                    link: '',
                    iframe: '',
                    title: '',
                    body: '',
                    sort: 0,

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // mobile image
                    mobile_image_preview: '',
                    mobile_image_base64: '',
                    mobile_image_alt: '',
                    mobile_image_title: '',

                    // status & visiblity
                    status: 1,

                    //language
                    language_id: '',
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'sliders',

                // language
                languages: [],
                languageLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchRow();
        },
        methods: {
            
            // fetch Row
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    // tenant
                    this.tenant_id = res.data.row.tenant_id;
                    this.tenant_name = res.data.row.tenant_name;
                    
                    // row
                    this.row.title = res.data.row.title;
                    this.row.body = res.data.row.body;
                    this.row.sort = res.data.row.sort;
                    this.row.button = res.data.row.button;
                    this.row.link = res.data.row.link;
                    this.row.iframe = res.data.row.iframe;
                    
                    // image
                    this.row.image_preview = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_base64 = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_alt = (res.data.row.image) ? res.data.row.image.image_alt : null;
                    this.row.image_title = (res.data.row.image) ? res.data.row.image.image_title : null;

                    // mobile image
                    this.row.mobile_image_preview = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_base64 = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_alt = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_alt : null;
                    this.row.mobile_image_title = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_title : null;

                    // status & visiblity
                    this.row.status = res.data.row.status;
                    //language
                    this.row.language_id = (res.data.row.language) ? res.data.row.language.id : null;
                    // call fetchLanguages func                    
                    this.fetchLanguages();
                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetch Language
            fetchLanguages(){
                this.languageLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/languages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                    .then(res => {
                        this.languageLoading = false;
                        this.languages = res.data.rows;
                    })
                    .catch(() => {})
                    .finally(() => {});
            },
            // edtiRow
            editRow(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {
                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };
                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            // row
                            title: this.row.title,
                            body: this.row.body,
                            sort: this.row.sort,
                            button: this.row.button,
                            link: this.row.link,
                            iframe: this.row.iframe,

                            // image 
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // mobile image 
                            mobile_image_base64: this.row.mobile_image_base64,
                            mobile_image_alt: this.row.mobile_image_alt,
                            mobile_image_title: this.row.mobile_image_title,

                            // status & visiblity
                            status: this.row.status,
                            
                            //language
                            language_id: this.row.language_id,
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Updated Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: err.response.data.message
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // Upload Featured image
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },

            // Upload Mobile Featured image
            onMobileImageChange(e){
                const file = e.target.files[0];
                this.row.mobile_image_preview = URL.createObjectURL(file);
                this.createBase64MobileImage(file);
            },
            createBase64MobileImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.mobile_image_base64 = e.target.result;
                };
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },

            // remove sessions
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            // toggleCollapse
            collapseToggle(div) {
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
